import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

export const autoscrollContainer: ThemeUICSSObject = {
  height: '100%',
  overflow: 'auto',
};
